module.exports = __webpack_public_path__ + "static/media/arrow-right.100c6f14.svg";